import { useRef } from 'react';
import { useOutsideClickDetector } from '../../../hooks/useOutsideClickDetector';
import { ToppingsEnum } from '../toppings_defs';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import IconButton from '../../../components/Button/IconButton/IconButton';
import GuessRow from './GuessRow';

import './history.css';

interface HistoryProps {
    guesses: ToppingsEnum[][];
    closeHistoryCb: () => void;
}

function History(props: HistoryProps) {
    const { guesses, closeHistoryCb } = props;
    const historyRef = useRef(null);
    useOutsideClickDetector(historyRef, closeHistoryCb);

    return (
        <div className="guess-history" ref={historyRef}>
            <div className="close-history">
                <IconButton
                    IconComponent={CloseIcon}
                    onClick={closeHistoryCb}
                />
            </div>
            <div className="history-title">Past guesses</div>
            {guesses.map((guess, index) => {
                return (
                    <div className="history-row" key={index}>
                        <div className="guess-number">{index + 1}</div>
                        <GuessRow toppings={guess} />
                    </div>
                );
            })}
        </div>
    );
}

export default History;
